import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const faqService = {
  getFAQRootCategories: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.faq.getFAQRootCategories,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFAQCategoryBySlug: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.faq.getFAQCategoryBySlug,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFAQBySlug: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.faq.getFAQBySlug,
      payload,
      headers,
      hasErrorHandler,
    }),
  searchFaq: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.faq.searchFaq,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFAQCategoryOrQuestion: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.faq.getFAQCategoryOrQuestion,
      payload,
      headers,
      hasErrorHandler,
    }),
};
